import { render } from "./SpeedLegend.vue?vue&type=template&id=45a097bb"
import script from "./SpeedLegend.vue?vue&type=script&lang=js"
export * from "./SpeedLegend.vue?vue&type=script&lang=js"

import "./SpeedLegend.vue?vue&type=style&index=0&id=45a097bb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__